import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { UserService } from 'src/app/services/user.service';
import { Options } from 'select2';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

declare var bootstrap: any;

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.css']
})
export class TagsComponent implements OnInit {
  isOK = false;

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  cadastroFrm: cadastroData = {
    loading: false,
    data: {
      nome: '',
      cor: ''
    }
  }

  modalCadastrar: any;

  editarFrm: editarData = {
    loading: false,
    data: {
      id: -1,
      nome: '',
      cor: ''
    }
  }

  modalEditar: any;

  options1!: Options;
  options2!: Options;

  public grupoData1 = [
    {
      id: 'dyn1',
      text: 'Dynamic 1',
    }
  ];

  constructor(public userService: UserService, private router: Router) { }

  ngOnInit(): void {
    if (this.userService.checarPermissao('22')[0]) {
      this.isOK = true;
    } else {
      return;
    }

    this.dtOptions = {
      language: this.userService.dataTableLanguage,
      ajax: {
        url: environment.apiEndpoint + 'tags-list',
        type: 'POST',
        dataType: 'json',
        contentType: "application/json",
        data: function (d) {
          return JSON.stringify(d);
        },
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        error: (xhr: any, error: any, code: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        }
      },
      pageLength: 10,
      processing: false,
      serverSide: true,
      columnDefs: [
        { "searchable": false, "targets": [2] },
        { "orderable": false, "targets": [2] },
      ],
      order: [[0, 'asc']],
      rowCallback: (row: Node, data: any[] | object, index: number) => {
        const id = Number($('button:eq(0)', row).attr('row_id'));
        $('button:eq(0)', row).off('click');
        $('button:eq(0)', row).on('click', (obj) => {
          const call = async () => {
            (obj.currentTarget as any).disabled = true;
            obj.currentTarget.innerHTML = '<span class="spinner-border spinner-border-sm"></span>';
            await this.fetchTag(id);
            (obj.currentTarget as any).disabled = false;
            obj.currentTarget.innerHTML = 'Editar';
          }
          call();
        });
        $('button:eq(1)', row).off('click');
        $('button:eq(1)', row).on('click', () => {
          this.Excluir(Number(id));
        });
        return row;
      },
    }

    this.modalCadastrar = new bootstrap.Modal(
      document.getElementById('cadastrar'),
      {
        backdrop: 'static',
      }
    );

    this.modalEditar = new bootstrap.Modal(
      document.getElementById('editar'),
      {
        backdrop: 'static',
      }
    );
  }

  Cadastrar() {
    this.cadastroFrm.loading = true;
    this.userService
      .cadastrarTag(
        this.cadastroFrm.data
      )
      .subscribe(
        (res: any) => {
          Swal.fire({
            title: 'Sucesso',
            text: 'Tag cadastrada',
            icon: 'success',
            heightAuto: false,
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              confirmButton: 'btn-swal'
            },
          });
          this.cadastroFrm.data = {
            nome: '',
            cor: ''
          };
          this.modalCadastrar.hide();
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.ajax.reload();
          });
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.cadastroFrm.loading = false
        },
        () => (this.cadastroFrm.loading = false)
      );
  }

  fetchTag(id: number) {
    this.editarFrm.loading = true;
    return new Promise((resolve) => {
      this.userService.fetchTag(id).subscribe(
        (res: any) => {
          this.editarFrm.data = res.data;
          this.modalEditar.show();
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.editarFrm.loading = false
        },
        () => (this.editarFrm.loading = false)
      ).add(() => {
        resolve('');
      });
    });
  }

  Editar() {
    this.editarFrm.loading = true;
    this.userService
      .editarTag(
        this.editarFrm.data
      )
      .subscribe(
        (res: any) => {
          Swal.fire({
            title: 'Sucesso',
            text: 'Tag editada',
            icon: 'success',
            heightAuto: false,
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              confirmButton: 'btn-swal'
            },
          });
          this.modalEditar.hide();
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.ajax.reload();
          });
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.editarFrm.loading = false
        },
        () => (this.editarFrm.loading = false)
      );
  }

  Excluir(id: number) {
    Swal.fire({
      title: 'Excluir Tag?',
      icon: 'warning',
      text: 'Este processo é irreversível',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Excluir',
      heightAuto: false,
      allowOutsideClick: false,
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn-swal',
        cancelButton: 'btn-swal-cancel',
      },
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return new Promise(() => {
          (this.userService.excluirTag(id).subscribe(
            (res: any) => {
              Swal.fire({
                title: 'Sucesso',
                text: 'Tag excluída',
                icon: 'success',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal',
                },
              });
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.ajax.reload();
              });
            },
            (err: any) => {
              switch (err.status) {
                case 400:
                  Swal.fire({
                    title: 'Erro',
                    text: String(err.error.message),
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
                case 401:
                  localStorage.removeItem('botway');
                  this.router.navigate(['/login']);
                  break;
                case 422:
                  let txt = '';
                  Object.values(err.error.errors).forEach((value: any, index) => {
                    for (let i = 0; i < Array(value).length; i++) {
                      txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                    }
                  });
                  Swal.fire({
                    title: 'Erro',
                    html: txt,
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
              }
            }
          ))
        });
      }
    });
  }
}

export interface cadastroData {
  loading: boolean;
  data: {
    nome: string;
    cor: string;
  }
}

export interface editarData {
  loading: boolean;
  data: {
    id: Number;
    nome: string;
    cor: string;
  }
}
